import React from 'react';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { useLocation, Link as RouterLink } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path: string;
  isLast: boolean;
}

interface BreadCrumbProps {
  customLabel?: string;
}

const BreadCrumb: React.FC<BreadCrumbProps> = ({ customLabel }) => {
  const location = useLocation();

  const getBreadcrumbItems = (): BreadcrumbItem[] => {
    const pathnames = location.pathname.split('/').filter(Boolean);

    return pathnames.map((segment, index) => {
      const isLast = index === pathnames.length - 1;
      return {
        label: isLast && customLabel ? customLabel : formatSegmentLabel(segment),
        path: `/${pathnames.slice(0, index + 1).join('/')}`,
        isLast,
      };
    });
  };

  const formatSegmentLabel = (segment: string): string => {
    // Handle kebab-case, snake_case, or regular segments
    return segment
      .split(/[-_]/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const breadcrumbItems = getBreadcrumbItems();

  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
      {breadcrumbItems.map(({ label, path, isLast }) =>
        isLast ? (
          <Typography color="text.primary" key={path}>
            {label}
          </Typography>
        ) : (
          <Link component={RouterLink} to={path} underline="none" color="inherit" key={path}>
            {label}
          </Link>
        )
      )}
    </Breadcrumbs>
  );
};

export default BreadCrumb;
